export default function FooterCar(){

    return(
        <footer style={{textAlign: 'center', backgroundColor:'white'}}>
                <p>
                    Certain high data usage vehicle features require at least Standard Connectivity, including maps, navigation and voice commands. Access to features that use cellular data and third-party licenses are subject to change. <a href="" className="ancora-footer">Learn more about Standard Connectivity and any limitations.</a>
                </p>
                <ul className="list-footer">
                    <li>
                        <a>Tesla © 2022</a>
                    </li>
                    <li>
                        <a>Privacy & Legal</a>
                    </li>
                    <li>
                        <a>Vehicle Recalls</a>
                    </li>
                    <li>
                        <a>Contact</a>
                    </li>
                    <li>
                        <a>Careers</a>
                    </li>
                    <li>
                        <a>Engage</a>
                    </li>
                    <li>
                        <a>Locations</a>
                    </li>
                </ul>
            </footer>
    )
}